import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  AfterViewInit,
  input,
  output,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject, Observable, of, combineLatest } from 'rxjs';
import { STAFF_STATE } from '@fitness-force/state';
import type { STAFFINTERFACE } from '@fitness-force/models';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
} from '@angular/forms';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';
import { StaffStoreService } from '@fitness-force/api';

@Component({
  selector: 'staff-selector[formGroup]',
  templateUrl: './assigned-to.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    ShortNamePipe,
    AvatarModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class AssignedToComponent implements OnInit, AfterViewInit {
  fb = inject(UntypedFormBuilder);
  private store = inject(Store);
  private staffStoreService = inject(StaffStoreService);

  readonly formGroup = input<UntypedFormGroup>(new UntypedFormGroup({}));
  readonly controlName = input<UntypedFormControl>(new UntypedFormControl());
  readonly staffId$ = input(new BehaviorSubject<number>(0), { alias: 'id' });
  readonly styleClass = input<string>('border-none surface-50 w-full');
  readonly placeHolder = input<string>('Select');
  readonly claims$ = input<Observable<string[]>>(of([]), { alias: 'claims' });
  readonly showClear = input<boolean>(true);
  readonly canRepresetative$ = input(new BehaviorSubject(false), {
    alias: 'canRepresetative',
  });
  readonly staffIds$ = input<Observable<number[]>>(of([-1]), {
    alias: 'filterstaff',
  });
  readonly selectedStaff = output<any>({ alias: 'selectedStaff' });
  staffs$ = new BehaviorSubject<STAFFINTERFACE[]>([]);
  allStaffs$ = new BehaviorSubject<STAFFINTERFACE[]>([]);

  claims: Observable<any> | any;

  ngOnInit(): void {
    this.GetStaffList();
    this.claims = this.claims$();
  }

  ngAfterViewInit(): void {
    const staffIdSubject = this.staffId$();
    if (staffIdSubject) {
      staffIdSubject.subscribe((res) => {
        this.SetSelectedStaff();
      });
    }
  }

  get SelectedStaff(): STAFFINTERFACE {
    return this.controlName().value;
  }

  GetStaffList(): void {
    combineLatest([
      this.store.select(STAFF_STATE),
      this.canRepresetative$(),
      this.staffIds$(),
    ]).subscribe({
      next: (res: Array<any>) => {
        if (res[0] && res[0].staffList && res[0].staffList.length > 0)
          this.staffs$.next(
            res[0].staffList.filter(
              (o: STAFFINTERFACE) => String(o.status).toLowerCase() == 'active',
            ),
          );

        if (res[0] && res[0].staffList && res[0].staffList.length > 0)
          //this.filterStaffs();
          this.SetSelectedStaff();

        if (res[1]) {
          this.staffs$.next(
            res[0].staffList.filter(
              (o: STAFFINTERFACE) =>
                String(o.status).toLowerCase() == 'active' &&
                o.can_be_client_rep,
            ),
          );
        }
        if (res[2] && res[2][0] != -1) {
          this.staffs$.next(
            res[0].staffList.filter((o: STAFFINTERFACE) =>
              res[2].includes(o.id),
            ),
          );
        }
      },
    });
  }

  onSelectStaff(event: any) {
    this.selectedStaff.emit(event);
  }

  SetSelectedStaff(): void {
    if (this.staffId$().value > 0) {
      let defaultSelectedStaff = this.staffs$.value.find(
        (o: STAFFINTERFACE) => o.id == this.staffId$().value,
      )!;
      if (defaultSelectedStaff && defaultSelectedStaff.id > 0) {
        this.controlName().setValue(defaultSelectedStaff);
      } else {
        this.staffStoreService
          .getStaffById(this.staffId$().value)
          .subscribe((staff) => {
            defaultSelectedStaff = staff!;
          });
        // defaultSelectedStaff = this.allStaffs$.value.find(
        //   (o: STAFFINTERFACE) => o.id == this.staffId$.value
        // );
        if (defaultSelectedStaff && defaultSelectedStaff.id > 0) {
          let staff: STAFFINTERFACE[] = this.staffs$.value;
          staff.push(defaultSelectedStaff || ({} as STAFFINTERFACE));
          this.staffs$.next(staff);
          this.controlName().setValue(defaultSelectedStaff);
        }
      }
    }
  }
}
